export default __webpack_public_path__ + "img/46dbbed48addfa4282d0f0f1adcfb52a.svg";